import { render, staticRenderFns } from "./Home2.vue?vue&type=template&id=00db7166&scoped=true"
import script from "./Home2.vue?vue&type=script&lang=ts"
export * from "./Home2.vue?vue&type=script&lang=ts"
import style1 from "./Home2.vue?vue&type=style&index=1&id=00db7166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00db7166",
  null
  
)

export default component.exports